/* global API, LANG */

import dataLayerHelper from '../helpers/dataLayer';

const $cart = $('.js-cart');
const $discount = $('.js-discount');
const $input = $('.js-discount-input');
const $btn = $('.js-discount-btn');
const $hidden = $('.js-discount-hidden');
const $message = $('.js-discount-message');
const $trigger = $('.js-discount-trigger');
const $content = $('.js-discount-content');

const MIN_DISCOUNT_LEN = 6;

const discount = {
  initialize() {
    if ($discount.length) {
      this.createListeners();
    }
  },

  createListeners() {
    if ($input.val() !== '') {
      $content.show();
      $trigger.hide();
    }

    $btn.on('click', () => {
      const val = $input.val();

      if (val.length > MIN_DISCOUNT_LEN) {
        this.runCheck(val);
        dataLayerHelper.event('Discount code add', 'submit', val);
      }
    });

    $trigger.on('click', () => {
      $content.show();
      $input.focus();
    });
  },

  runCheck(val) {
    $.ajax({
      url: `${API.discount}?code=${val}`,
      success: (res) => {
        this.outputMessage(res, 'ok');
        this.handleDiscount(res);
      },
      error: (res) => {
        this.outputMessage(res.responseJSON, 'error');
        this.handleDiscount(res.responseJSON);
      },
    });
  },

  outputMessage(res, status) {
    const msg = typeof res.message !== 'undefined' ? res.message : LANG.discountAPIError;

    $message
      .text(msg)
      .removeClass('u-color-positive u-color-negative')
      .addClass(status === 'ok' ? 'u-color-positive' : 'u-color-negative');
  },

  handleDiscount(res) {
    if (typeof res.discount === 'undefined') {
      return;
    }

    $hidden.attr('data-coupon-type', res.type);

    const discountVal = res.discount;

    $hidden.val(discountVal).trigger('change');
    $cart.trigger('recalculate');
  },
};

export default discount;
